"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CodeLayerFieldComponents = exports.updateCodeAssessmentIcon = exports.findCodeAssessmentRiskEntry = exports.AppliedClassNames = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@chakra-ui/react");
var react_2 = __importDefault(require("react"));
var svg_icons_1 = __importDefault(require("../../svgs/svg-icons"));
var classnames_1 = __importDefault(require("classnames"));
var ui_common_1 = require("@codametrix/ui-common");
var FieldType = ui_common_1.commonEnums.FieldType, CodeAssessmentRiskCategory = ui_common_1.commonEnums.CodeAssessmentRiskCategory;
var ui_common_2 = require("@codametrix/ui-common");
var code_field_component_1 = __importDefault(require("./field-components/code-field-component"));
var text_input_field_component_1 = __importDefault(require("./field-components/text-input-field-component"));
var _a = ui_common_2.workBench.pathUtils, getValueAtPath = _a.getValueAtPath, getOptionsFromTree = _a.getOptionsFromTree;
// TODO : Move AppliedClassNames to new file (all of this should be in UI-Components)
// Recursivley Applies Classnames
var AppliedClassNames = function (_a) {
    var value = _a.value, classNames = _a.classNames;
    if (classNames.length == 0) {
        return (0, jsx_runtime_1.jsx)("span", { children: value });
    }
    // Recursively applies classNames to nested spans
    var innerSpan = function (index) {
        if (index == classNames.length - 1) {
            return (0, jsx_runtime_1.jsx)("span", __assign({ className: (0, classnames_1["default"])(classNames[index]) }, { children: value }));
        }
        return ((0, jsx_runtime_1.jsxs)("span", __assign({ className: (0, classnames_1["default"])(classNames[index]) }, { children: [' ', innerSpan(index + 1)] })));
    };
    return innerSpan(0);
};
exports.AppliedClassNames = AppliedClassNames;
var IconComponent = function (_a) {
    var field = _a.field;
    var IconComponent = field.svgIconName ? ((0, jsx_runtime_1.jsx)(svg_icons_1["default"], { svgIconName: field.svgIconName, svgIconClass: field.svgIconClass, svgIconSize: field.svgIconSize, svgViewBox: field.svgIconSize, svgTitleText: field.svgIconName })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}));
    var classnames = field.classNames;
    var handleClick = function (e) {
        e.preventDefault();
        if (field.onSelect) {
            field.onSelect(field.key);
        }
    };
    return ((0, jsx_runtime_1.jsx)(react_1.Box, __assign({ onClick: handleClick, cursor: field.onSelect ? 'pointer' : 'default' }, { children: (0, jsx_runtime_1.jsx)(exports.AppliedClassNames, { classNames: field.classNames, value: IconComponent }) })));
};
var SelectListFieldComponent = function (_a) {
    var field = _a.field, value = _a.value;
    var handleSelect = function (e) {
        field.onSelect(field.path, e.target.value, value);
    };
    var options = field['options'] ? field['options'] : field['defaultOptions'];
    if (field.optionsTree) {
        var optionsAtTree = getOptionsFromTree(value, field.optionsTree, field.optionsTreePath);
        if (optionsAtTree) {
            options = optionsAtTree;
        }
    }
    var key = field.rerenderFields.map(function (field) { return value[field]; }).join('-');
    return ((0, jsx_runtime_1.jsxs)("select", __assign({ className: "form-select", disabled: field.readonly, value: getValueAtPath(value, field.path), onChange: handleSelect }, { children: [(0, jsx_runtime_1.jsx)("option", __assign({ value: "", disabled: true, selected: true }, { children: field.placeholder })), options.map(function (option) { return ((0, jsx_runtime_1.jsx)("option", __assign({ value: option }, { children: option }), option)); })] }), key));
};
// Placeholder component for ButtonField
var ButtonFieldComponent = function (_a) {
    var field = _a.field;
    return ((0, jsx_runtime_1.jsx)("button", __assign({ onClick: function () { return console.log(field.action); } }, { children: field.icon && (0, jsx_runtime_1.jsx)("span", { children: field.icon }) })));
};
//Sets widths of fields using chakra grid
//React to screen size?
//Recommend 4 or less fields
//Todo : Padding fr if fr total < 10 or does muy grid automatically align center
function generateTemplateColumns(draggable, expandable, fieldFractions) {
    var calculateFractions = fieldFractions.reduce(function (acc, fraction) {
        return acc + "".concat(fraction, " ");
    }, '');
    return calculateFractions;
}
function mapCategorytoSvgName(category) {
    if (!category) {
        return '';
    }
    switch (category) {
        case CodeAssessmentRiskCategory.CORRECT:
            return 'CheckCircle1';
        case CodeAssessmentRiskCategory.INCORRECT:
            return 'WrongCode1';
        case CodeAssessmentRiskCategory.MISSED:
            return 'PlusCircle1';
        default:
            return '';
    }
}
function findCodeAssessmentRiskEntry(code, cqaCodeAssessmentRiskDictionaries) {
    if (!code ||
        !code.codeAssessment ||
        !code.codeType ||
        !cqaCodeAssessmentRiskDictionaries) {
        return null;
    }
    var assessment = code.codeAssessment.assessment;
    var role = code.codeAssessment.role;
    var codeType = code.codeType;
    return cqaCodeAssessmentRiskDictionaries[codeType].rows.find(function (row) { return row.assessment == assessment && row.role == role; });
}
exports.findCodeAssessmentRiskEntry = findCodeAssessmentRiskEntry;
function updateCodeAssessmentIcon(field, code, cqaCodeAssessmentRiskDictionaries) {
    if (field.key !== 'baseCQACodeAssessmentIcon') {
        return field;
    }
    var row = findCodeAssessmentRiskEntry(code, cqaCodeAssessmentRiskDictionaries);
    if (!row) {
        return field;
    }
    return __assign(__assign({}, field), { svgIconName: mapCategorytoSvgName(row.category) });
}
exports.updateCodeAssessmentIcon = updateCodeAssessmentIcon;
function componentForField(field, code, cqaCodeAssessmentRiskDictionaries) {
    if (field.hidden) {
        return null;
    }
    switch (field.fieldType) {
        case FieldType.SelectList:
            return (0, jsx_runtime_1.jsx)(SelectListFieldComponent, { field: field, value: code });
        case FieldType.Button:
            return (0, jsx_runtime_1.jsx)(ButtonFieldComponent, { field: field });
        case FieldType.Text:
            return ((0, jsx_runtime_1.jsx)(exports.AppliedClassNames, { classNames: field.classNames, value: getValueAtPath(code, field.key) }));
        case FieldType.Icon:
            if (field.key === 'baseCQACodeAssessmentIcon') {
                var updatedField = updateCodeAssessmentIcon(field, code, cqaCodeAssessmentRiskDictionaries);
                return (0, jsx_runtime_1.jsx)(IconComponent, { field: updatedField });
            }
            return (0, jsx_runtime_1.jsx)(IconComponent, { field: field });
        case FieldType.Code:
            var classNamesMedicalCodeChip = [];
            var row = findCodeAssessmentRiskEntry(code, cqaCodeAssessmentRiskDictionaries);
            if (row && row.category == CodeAssessmentRiskCategory.INCORRECT) {
                classNamesMedicalCodeChip.push('incorrect-medical-code');
            }
            return ((0, jsx_runtime_1.jsx)(code_field_component_1["default"], { field: field, value: code, classNamesMedicalCodeChip: classNamesMedicalCodeChip }));
        case FieldType.TextInput:
            return (0, jsx_runtime_1.jsx)(text_input_field_component_1["default"], { field: field, value: code });
        default:
            return null; // Handle unknown field types gracefully
    }
}
function createGridItems(expandable, fieldsComponents) {
    var components = [];
    var fieldGridItems = fieldsComponents.map(function (component) { return ((0, jsx_runtime_1.jsx)(react_1.GridItem, __assign({ w: "100%" }, { children: component }))); });
    components = __spreadArray(__spreadArray([], __read(components), false), __read(fieldGridItems), false);
    if (expandable) {
        components.push((0, jsx_runtime_1.jsx)(react_1.GridItem, __assign({ w: "100%" }, { children: " \\/" })));
    }
    return components;
}
// Could also be called "Row", it is based off of fields, nothing code specific
var GenericCodeLayer = function (props) {
    var fields = props.fields, expandableOptions = props.expandableOptions, values = props.values, classNames = props.classNames, cqaCodeAssessmentRiskDictionaries = props.cqaCodeAssessmentRiskDictionaries;
    var _itemRef = react_2["default"].useRef(null);
    var columns = fields.reduce(function (acc, field) {
        var temp = acc;
        if (!field.hidden) {
            temp.push(field.width);
        }
        return temp;
    }, []);
    var templateColumns = generateTemplateColumns(true, false, columns);
    //Get the components for each field
    var mapped = fields
        .map(function (field) {
        return componentForField(field, values, cqaCodeAssessmentRiskDictionaries);
    })
        .filter(function (item) { return item !== null; });
    //Wrap component for each field
    var gridItems = createGridItems(false, mapped);
    //If expandable, add expandable component
    var displayExpandable = expandableOptions
        ? expandableOptions.shouldDisplay(fields)
        : false;
    var ExpandComponent = (expandableOptions === null || expandableOptions === void 0 ? void 0 : expandableOptions.component) ? (expandableOptions.component) : ((0, jsx_runtime_1.jsx)("div", { children: "No expandable Options" }));
    var classes = (0, classnames_1["default"])(classNames);
    return ((0, jsx_runtime_1.jsxs)(react_1.Box, __assign({ ref: _itemRef }, { children: [(0, jsx_runtime_1.jsx)(react_1.Grid, __assign({ templateColumns: templateColumns, gap: 0, alignItems: 'center', className: classes }, { children: gridItems })), (0, jsx_runtime_1.jsx)(react_1.Box, __assign({ display: displayExpandable ? 'block' : 'none', className: classes }, { children: ExpandComponent }))] })));
};
//Public Component
exports["default"] = GenericCodeLayer;
//"Private" exports for unit testing
exports.CodeLayerFieldComponents = {
    SelectListFieldComponent: SelectListFieldComponent
    //Add more components as needed
};
//# sourceMappingURL=code-layer.js.map